import script from "./list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-item.vue?vue&type=script&setup=true&lang=ts"

import "./list-item.vue?vue&type=style&index=0&id=00826778&lang=postcss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00826778"]])

export default __exports__